import { LOG_ACTIONS, logAction } from '@namespace/analytics';
import { WIDGET_TYPES } from '../../constants';
import { useGetLobbyPageUrl } from '../useGetLobbyPageUrl';

export const useCollectionsSingleCard = ({ onClose, category, casinoType }) => {
  const {
    title,
    nameTranslationKey,
    logo,
    id: collectionCategoryId,
    categoryGames,
    total
  } = category;
  const lobbyPageUrl = useGetLobbyPageUrl(casinoType);
  const categoryLink = `${lobbyPageUrl}/${WIDGET_TYPES.COLLECTIONS}/${collectionCategoryId}`;

  const onCardClick = () => {
    logAction(LOG_ACTIONS.OPEN_COLLECTION_CLICK, {
      collectionName: collectionCategoryId
    });
    onClose?.();
  };

  return {
    title,
    logo,
    collectionCategoryId,
    categoryGames,
    total,
    onCardClick,
    categoryLink,
    nameTranslationKey
  };
};
